export default __webpack_public_path__ + "static/media/meta-mask.3b2e81e6.svg";